import $ from 'jquery'

var tokkyoExpand = {
  init: function () {
    var $toggles = $('.js-tokkyo-toggle')
    $toggles.each(function () {
      var $btn = $(this)
      var $expand = $btn.closest('.p-tokkyo-section, .p-lower-block__inner').find('.js-tokkyo-expand')

      $btn.on('click', function () {
        $expand.removeClass('_collapsed')
        $btn.hide()
      })
    })

    var $tabs = $('.p-tokkyo-anchor__tab, .p-research-anchor__tab, .p-inquiry-anchor__tab')
    if (!$tabs.length) return

    $tabs.on('click', function (e) {
      e.preventDefault()
      var target = $(this).attr('href')
      var $siblings = $(this)
        .closest('.p-tokkyo-anchor__inner, .p-research-anchor__inner, .p-inquiry-anchor__inner')
        .find('a')

      $siblings.removeClass('_active')
      $(this).addClass('_active')

      if ($(target).length) {
        $('html, body').animate({ scrollTop: $(target).offset().top }, 400)
      }
    })
  },
}

export default tokkyoExpand
